/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SystemDropdownOptionParam } from './SystemDropdownOptionParam';
import {
    SystemDropdownOptionParamFromJSON,
    SystemDropdownOptionParamFromJSONTyped,
    SystemDropdownOptionParamToJSON,
    SystemDropdownOptionParamToJSONTyped,
} from './SystemDropdownOptionParam';

/**
 * 
 * @export
 * @interface UpsertSystemDropdownOptionsRequest
 */
export interface UpsertSystemDropdownOptionsRequest {
    /**
     * 
     * @type {Array<SystemDropdownOptionParam>}
     * @memberof UpsertSystemDropdownOptionsRequest
     */
    options: Array<SystemDropdownOptionParam>;
}

/**
 * Check if a given object implements the UpsertSystemDropdownOptionsRequest interface.
 */
export function instanceOfUpsertSystemDropdownOptionsRequest(value: object): value is UpsertSystemDropdownOptionsRequest {
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function UpsertSystemDropdownOptionsRequestFromJSON(json: any): UpsertSystemDropdownOptionsRequest {
    return UpsertSystemDropdownOptionsRequestFromJSONTyped(json, false);
}

export function UpsertSystemDropdownOptionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertSystemDropdownOptionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'options': ((json['options'] as Array<any>).map(SystemDropdownOptionParamFromJSON)),
    };
}

export function UpsertSystemDropdownOptionsRequestToJSON(json: any): UpsertSystemDropdownOptionsRequest {
    return UpsertSystemDropdownOptionsRequestToJSONTyped(json, false);
}

export function UpsertSystemDropdownOptionsRequestToJSONTyped(value?: UpsertSystemDropdownOptionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'options': ((value['options'] as Array<any>).map(SystemDropdownOptionParamToJSON)),
    };
}

